export enum LoadingState {
  idle = "idle",
  pending = "pending",
  succeed = "succeed",
  notFound = "not-found",
  failed = "failed",
}
